import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useCallback, useMemo } from "react";

export const StatusFilter = (options: ColumnFilterElementTemplateOptions) => {
    const statusOptions = useMemo(
        () => [
            { label: "Open", value: 0 },
            { label: "Closed", value: 1 },
            { label: "In Progress", value: 2 },
            { label: "Rectified", value: 3 },
            { label: "Expired", value: 4 }
        ],
        []
    );

    const onChange = useCallback(
        (e: MultiSelectChangeEvent) => {
            options.filterApplyCallback(e.value);
        },
        [options]
    );

    return (
        <MultiSelect
            value={options.value}
            options={statusOptions}
            onChange={onChange}
            showClear
            filter
            placeholder="Show all"
            scrollHeight="400px"
            style={{ width: 132 }}
        />
    );
};
